import type {
  FinalizeResponse,
  PackagedComponentV2Enum,
} from "@capone/packages-api";
import { FinalizePackageResponse, RequoteReasonEnum } from "redmond";

// Inlined string literals instead of importing PackagedComponentV2Enum as a runtime value —
// this app's webpack config excludes node_modules from the TS/JS loader, and
// @capone/packages-api ships only raw .ts source with no compiled output, so any runtime
// (non-type-only) import from it fails to bundle.
const PACKAGED_AIR: PackagedComponentV2Enum = "PackagedAir";
const PACKAGED_ROOM: PackagedComponentV2Enum = "PackagedRoom";

export const convertFinalizeResponseToFinalizePackageResponse = (
  response: FinalizeResponse
): FinalizePackageResponse => {
  const air = response.packageDisplayData.products.find(
    (product) => product.component.componentType === PACKAGED_AIR
  )?.component;
  const room = response.packageDisplayData.products.find(
    (product) => product.component.componentType === PACKAGED_ROOM
  )?.component;

  if (air == null || air.componentType !== PACKAGED_AIR) {
    throw new Error(
      "convertFinalizeResponseToFinalizePackageResponse: missing PackagedAir component"
    );
  }
  if (room == null || room.componentType !== PACKAGED_ROOM) {
    throw new Error(
      "convertFinalizeResponseToFinalizePackageResponse: missing PackagedRoom component"
    );
  }
  if (air.fareId == null) {
    throw new Error(
      "convertFinalizeResponseToFinalizePackageResponse: PackagedAir missing fareId"
    );
  }
  if (air.lodgingStayDates == null) {
    throw new Error(
      "convertFinalizeResponseToFinalizePackageResponse: PackagedAir missing lodgingStayDates"
    );
  }
  const opaqueQuoteRequest = room.shopDetails?.opaqueQuoteRequest;
  if (opaqueQuoteRequest == null) {
    throw new Error(
      "convertFinalizeResponseToFinalizePackageResponse: PackagedRoom missing shopDetails.opaqueQuoteRequest"
    );
  }

  return {
    lodgingOpaqueQuoteRequest: opaqueQuoteRequest,
    flightTripId: air.tripId,
    flightFareId: air.fareId,
    lodgingStayDates: air.lodgingStayDates,
    // Hardcoded, not read from response.requoteReason.RequoteReason: @capone/packages-api's
    // RequoteReason type currently has only one variant (StayDatesMismatch). If v2 ever adds
    // another, this must switch on the actual field instead of assuming the single value.
    requoteReason:
      response.requoteReason != null
        ? {
            RequoteReason: RequoteReasonEnum.StayDatesMismatch,
            originalStayDates: response.requoteReason.originalStayDates,
            selectedStayDates: response.requoteReason.selectedStayDates,
          }
        : undefined,
  };
};
